<!-- eslint-disable eqeqeq -->
<template>
  <div
    class="select-with-search-table"
    @click="() => $refs.searchInput.focus()"
  >
    <!-- <el-input
      tabindex="-1"
      type="text"
      style="visibility: hidden; width: 0; height: 0; padding: 0"
    /> -->
    <div v-if="label" class="select-with-search__label label">
      <label>{{ label }}</label>
    </div>

    <el-popover
      v-model="showDropdown"
      trigger="manual"
      popper-class="select-with-search__popover"
      placement="bottom-end"
      :close-delay="0"
      :width="dropdownWidthComputed"
    >
      <div ref="dropdown" class="select__dropdown-wrapper">
        <div>
          <input
            ref="searchInput"
            v-model="filterText"
            class="select__search-field"
            type="text"
            :placeholder="searchPlaceHolder"
            @input="onInput"
          />
        </div>
        <div
          :style="{ height: gridWrapperHeight + 'px' }"
          class="select__table-wrapper"
        >
          <GridVx
            ref="agGrid"
            style="width: 100%"
            :row-selection="multiple ? 'multiple' : 'single'"
            :columns="columns"
            :get-row-style="getRowStyle"
            :get-row-class="getRowClass"
            :rows="filterRows"
            dom-layout="scroll"
            class="agGrid"
            :suppress-row-hover-highlight="suppressRowHoverHighlight"
            :auto-select-first-row="false"
            :auto-size-cell="true"
            :row-class-rules="rowClassRules"
            :is-external-filter-present="isExternalFilterPresent"
            :does-external-filter-pass="doesExternalFilterPass"
            :row-multi-select-with-click="multiple"
            :overlay-no-rows-template="overlayNoRowsTemplate"
            :header-height="gridHeaderHeight"
            @rowClicked="onSelectionChanged"
          />
        </div>
      </div>
      <div ref="select-input" slot="reference">
        <div
          v-click-outside="() => (showDropdown = false)"
          class="select-with-search"
          :class="[
            {
              disabled: disabled,
              readonly: readonly
            },
            `select-with-search__${size}`
          ]"
        >
          <div class="select__control" @click="onClickWrapper">
            <div class="select__value">
              <slot name="value" :selectedValue="selectedData" />
            </div>
            <div class="select__indicator">
              <template
                v-if="selectedIndexFieldValue && isRemoveBtn && selectedData"
              >
                <div
                  class="select__clear-indicator"
                  @click.stop="removeSelectedRow"
                >
                  <i class="el-icon-close" />
                </div>
                <div class="select__indicator-separator" />
              </template>
              <div class="select__dropdown-indicator">
                <i class="el-icon-caret-bottom" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
/* eslint-disable */
import clickOutSide from '@/directive/click-outside/index'

import { DEFAULT_GRID_HEADER_HEIGHT, DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

// const overlayNoRowsTemplate = '<span>Không có dữ liệu </span>'

export default {
  directives: {
    'click-outside': clickOutSide
  },
  props: {
    suppressRowHoverHighlight: {
      type: Boolean
    },
    getRowStyle: {
      type: Function
    },
    getRowClass: {
      type: Function
    },
    label: {
      default: '',
      type: String
    },
    searchFields: {
      type: Array,
      default: () => []
    },
    searchPlaceHolder: {
      type: String,
      default: function () {
        return this.$t('infoMsg.enterSearchInformation')
      }
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    rows: {
      type: Array,
      required: true,
      default: () => []
    },
    // The field in the row data to be used as an index (for filter)
    indexField: {
      type: String,
      required: true
    },
    // The value of the selected index field.
    selectedIndexFieldValue: {
      type: [String, Number, Array],
      default: null
    },
    isRemoveBtn: {
      default: false,
      type: Boolean
    },
    dropdownWidth: {
      type: Number
    },
    /**
     * @type {[String, Number, Array]}
     * @description To use with Vee-validate
     */
    value: {
      type: [String, Number, Array],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: function (val) {
        return ['medium', 'small', 'mini'].includes(val)
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      overlayNoRowsTemplate: '<span>Không có dữ liệu </span>',

      showDropdown: false,
      filterText: '',
      filterRows: [],
      selectedData: null,
      rowClassRules: {
        // 'test-class': params => params.data[this.indexField].toString() === this.selectedIndexFieldValue.toString()
      },
      dropdownWidthComputed: null,
      gridWrapperHeight: DEFAULT_GRID_HEADER_HEIGHT
    }
  },
  computed: {
    gridHeaderHeight() {
      return DEFAULT_GRID_HEADER_HEIGHT
    }
  },
  watch: {
    showDropdown(val) {
      if (!val) {
        setTimeout(() => {
          this.filterRows = [...this.rows]
          this.filterText = ''
        }, 500)
      } else {
        this.setDropdownWrapperWidth()
        this.initGridWrapperHeight()
        this.setSelectedRow(this.selectedIndexFieldValue)
      }
    },
    rows(val) {
      this.filterRows = [...val]
      this.fnGetSelectedRow()
    },
    selectedIndexFieldValue(val) {
      this.fnGetSelectedRow()
    },
    filterRows: {
      deep: true,
      handler(val) {
        setTimeout(() => {
          // if (this.selectedIndexFieldValue) {
          this.setSelectedRow(this.selectedIndexFieldValue)
          // }
        })
      }
    }
  },
  mounted() {
    this.filterRows = [...this.rows]
    this.gridApi = this.$refs.agGrid.gridApi
    this.fnGetSelectedRow()
    this.$nextTick(() => {
      this.setDropdownWrapperWidth()
      this.initGridWrapperHeight()
    })
  },
  methods: {
    isExternalFilterPresent() {
      return this.filterText !== null
    },
    doesExternalFilterPass(node) {
      // console.log(node)
      if (node.data) {
        // console.log(1111, 'check filter')
        const text = this.filterText.toLowerCase()
        let isPass = false
        if (this.searchFields.length) {
          isPass = this.searchFields.some(field => {
            const fieldVal = node.data[`${field}`]

            return fieldVal?.toString().toLocaleLowerCase().includes(text)
          })
        } else {
          isPass = Object.values(node.data).some(value => {
            if (value === null || value === undefined) {
              return false
            }
            if (value.toString().toLocaleLowerCase().includes(text)) {
            }
            return value.toString().toLocaleLowerCase().includes(text)
          })
        }
        return isPass
      }
      return false
    },
    fnSetSelectedRow(val) {
      this.selectedData = val
      this.$emit('selectionChanged', val)
      // this.setSelectedRow
    },
    fnGetSelectedRow() {
      let selectedData = null
      if (this.selectedIndexFieldValue) {
        /**
         * 1. Check if it's able to select multiple row
         * 1.1. If able -> convert selected props, and row's indexField data to String for check including
         * 1.2. If not, compare value
         */
        if (this.multiple) {
          if (this.selectedIndexFieldValue.length) {
            const selectedStringArr = this.selectedIndexFieldValue.map(item =>
              item.toString()
            )
            selectedData = this.rows.filter(row => {
              return selectedStringArr.includes(
                row?.[this.indexField].toString()
              )
            })
          }
        } else {
          selectedData = this.rows.find(row => {
            // eslint-disable-next-line eqeqeq
            return row?.[this.indexField] === this.selectedIndexFieldValue
          })
        }
        // console.log('fn get selected Row', selectedData)
        // this.fnSetselectedData(selectedData)
      }
      this.selectedData = selectedData
    },
    onSelectionChanged(rows) {
      const selectedData = this.multiple ? rows : rows[0]
      this.fnSetSelectedRow(selectedData)
      if (!this.multiple) {
        this.showDropdown = false
      }
    },
    // onSelectionMultiChange(rows) {
    //   if (this.multiple) {
    //     const selectedData = rows
    //     this.fnSetSelectedRow(selectedData)
    //   }
    // },
    onInput(e) {
      this.filterText = e.target.value
      this.gridApi.onFilterChanged()

      // Set grid height based on filter rows' length
      if (this.gridApi.getModel().rowsToDisplay?.length == 0) {
        this.gridApi.showNoRowsOverlay()
      } else {
        this.gridApi.hideOverlay()
      }

      this.setGridWrapperHeight(this.gridApi.getModel().rowsToDisplay?.length)
      // const text = e.target.value.toLowerCase()

      // if (this.searchFields.length) {
      //   this.filterRows = this.rows.filter((row) =>
      //     this.searchFields.some((field) => {
      //       const fieldVal = row[`${field}`]
      //       return fieldVal?.toString().toLocaleLowerCase().includes(text)
      //     })
      //   )
      // } else {
      //   this.filterRows = this.rows.filter((row) =>
      //     Object.values(row).some((value) => {
      //       if (value === null || value === undefined) {
      //         return false
      //       }
      //       if (value.toString().toLocaleLowerCase().includes(text)) {
      //         console.log(value)
      //       }
      //       return value.toString().toLocaleLowerCase().includes(text)
      //       // value?.toLowerCase().includes(filterTextLowerCase)
      //     })
      //   )
      // }
    },
    onClickWrapper(e) {
      if (!this.disabled && !this.readonly) {
        this.showDropdown = !this.showDropdown
      }
      // console.log('Toggle show')
    },
    onBlurWrapper() {
      this.showDropdown = false
      // console.log('Hide')
    },
    /* SET SELECTED ROW in TABLE */
    setSelectedRow(fieldVal) {
      if (!fieldVal || (this.multiple && !fieldVal?.length)) {
        // console.log('De-select all')
        this.gridApi.deselectAll()
        return
      }

      if (this.multiple) {
        // If multiple -> fieldVal's type is Array -> Convert to Array of String for compare with node's data
        const fieldValueArr = fieldVal.map(item => item.toString())
        this.gridApi.forEachNode(node => {
          // eslint-disable-next-line eqeqeq
          const nodeFieldValue = node.data?.[this.indexField]?.toString()
          if (fieldValueArr.includes(nodeFieldValue)) {
            node.setSelected(true)
          }
        })
      } else {
        this.gridApi.forEachNode(node => {
          if (
            node.data?.[this.indexField]?.toString() === fieldVal.toString()
          ) {
            node.setSelected(true)
          }
        })
      }
    },
    removeSelectedRow() {
      this.fnSetSelectedRow(null)
      this.setSelectedRow(null)
    },

    setDropdownWrapperWidth() {
      this.$nextTick(() => {
        if (this.dropdownWidth) {
          this.dropdownWidthComputed = this.dropdownWidth
        } else {
          this.dropdownWidthComputed = this.$refs['select-input']?.offsetWidth
        }
        // console.log('Computed width', this.dropdownWidthComputed)
      })
    },
    initGridWrapperHeight() {
      // console.log(this.rows.length)
      if (!this.rows?.length) {
        this.gridWrapperHeight =
          DEFAULT_GRID_HEADER_HEIGHT + DEFAULT_GRID_ROW_HEIGHT // FOR DISPLAY EMPTY MESSAGE (1 for border)
      } else {
        const newWrapperHeight =
          DEFAULT_GRID_HEADER_HEIGHT +
          this.rows.length * DEFAULT_GRID_ROW_HEIGHT +
          1
        this.gridWrapperHeight = Math.min(newWrapperHeight, 350) // Max height <= 350px
      }
    },

    // Set grid height after filter rows
    setGridWrapperHeight(rowsLength = 0) {
      if (!rowsLength) {
        this.gridWrapperHeight =
          DEFAULT_GRID_HEADER_HEIGHT + DEFAULT_GRID_ROW_HEIGHT // FOR DISPLAY EMPTY MESSAGE (1 for border)
      } else {
        const newWrapperHeight =
          DEFAULT_GRID_HEADER_HEIGHT + rowsLength * DEFAULT_GRID_ROW_HEIGHT + 1
        this.gridWrapperHeight = Math.min(newWrapperHeight, 350) // Max height <= 350px
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';
// .select-with-search__label {
//   font-size: 14px;
//   color: #606266;
// }

.select-with-search {
  position: relative;
  width: 100%;
  height: 32px;
  background-color: $input-bg-color;
  border-radius: 5px;
  // border: 1px solid rgb(220, 223, 230);

  &.select-with-search__medium {
    height: 32px;
  }

  &.select-with-search__small {
    height: 28px;
  }

  &.select-with-search__mini {
    height: 24px;
  }

  &.disabled,
  &.readonly {
    .select__control {
      pointer-events: none !important;
    }
  }

  &.disabled {
    cursor: not-allowed !important;
    background-color: $bg-disabled;
  }

  &.readonly {
    cursor: default !important;
    background-color: $input-bg-color !important;
  }

  .select__control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding-left: 15px;
    cursor: pointer;

    .select__value {
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 0.875rem;
      color: #000;
    }

    .select__indicator {
      display: flex;
      height: 100%;
      align-items: center;

      .select__indicator-separator {
        width: 1px;
        background-color: #ddd;
        height: 70%;
      }

      .select__clear-indicator,
      .select__dropdown-indicator {
        padding: 10px;
        line-height: 1rem;

        i {
          color: #a7a7a7;
        }

        &:hover {
          i {
            color: #5c5c5c;
          }
        }
      }

      .select__clear-indicator {
      }
      .select__dropdown-indicator {
      }
    }
  }

  // .select__value {
  //   width: 100%;
  //   height: 100%;
  //   line-height: 36px;
  //   padding: 0 15px;
  //   font-size: 0.825rem;
  // }

  // .select__suffix {
  //   position: absolute;
  //   right: 10px;
  //   // width: 25px;
  //   top: 0;
  //   bottom: 0;

  //   .select__suffix-inner {
  //     // display: inline-block;
  //     line-height: 36px;
  //     // text-align: center;

  //     width: 55px;
  //   display: flex;
  //   justify-content: space-between;
  //   }
  // }

  &::before {
    display: block;
    content: '';
    width: 100%;
    height: 14px;
    position: absolute;
    bottom: -10px;
  }
}

.select__dropdown-wrapper {
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  // position: absolute;
  // top: calc(100% + 6px);
  // right: 0;
  min-width: 250px;
  // min-width: 80%;
  // border-top: 1px solid #fff;
  // border-bottom: 1px solid #fff;
  padding-bottom: 8px;
  max-height: 400px;
  overflow: hidden;
  background-color: #fff;
  z-index: 10;

  .select__search-field {
    background-color: $input-bg-color;
    font-size: 0.875rem;
    width: 100%;
    height: 36px;
    padding: 4px 10px;
    border: none;
    outline: none;
  }

  // GRID
  .ag-center-cols-viewport {
    overflow-x: hidden !important;
  }
}
</style>

<style lang="scss">
.el-popover.el-popper.select-with-search__popover {
  padding: 0 !important;
  box-shadow: none;
  overflow: hidden;
  border-radius: 5px;

  &[x-placement^='bottom'] {
    margin-top: 10px;
  }

  &[x-placement^='top'] {
    margin-bottom: 10px;
  }

  .select__dropdown-wrapper + .popper__arrow {
    display: none;
  }
}
</style>
